export interface Testimonial {
  id: string;
  name: string;
  role: string;
  text: string;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Ahmed Raza',
    role: 'Private Training Student',
    text: 'Training with Moin Khan completely changed my life. In 6 months, I went from zero boxing experience to competing in amateur fights. The discipline and confidence I gained transferred into every area of my life.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20fit%20Pakistani%20man%20with%20confident%20expression%2C%20dark%20background%20with%20dramatic%20red%20rim%20lighting%2C%20sports%20portrait%20photography%2C%20high%20quality%20studio%20lighting&width=100&height=100&seq=avatar-ahmed&orientation=squarish',
  },
  {
    id: 't2',
    name: 'Bilal Khan',
    role: 'Youth Program Parent',
    text: 'My son joined the youth program 8 months ago and the transformation is incredible. His focus in school improved, he stands taller, and he has so much more confidence. The discipline they teach here is unmatched.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20middle-aged%20Pakistani%20man%20with%20warm%20genuine%20smile%2C%20dark%20background%20with%20dramatic%20red%20rim%20lighting%2C%20sports%20portrait%20photography%2C%20high%20quality%20studio%20lighting&width=100&height=100&seq=avatar-bilal&orientation=squarish',
  },
  {
    id: 't3',
    name: 'Fahad Sheikh',
    role: 'Group Training Member',
    text: 'The group training sessions are intense but incredibly rewarding. The energy in the gym pushes you further than you thought possible. I have lost 15kg and gained muscle, but more importantly, I found a community.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20fit%20athletic%20Pakistani%20man%20in%20his%2030s%20with%20determined%20expression%2C%20dark%20background%20with%20dramatic%20red%20rim%20lighting%2C%20sports%20portrait%20photography%2C%20high%20quality%20studio%20lighting&width=100&height=100&seq=avatar-fahad&orientation=squarish',
  },
];
